import DynamicFieldsFragment from '@linc-technologies/linced-common/models/dynamic-field/base-fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type MedicalConditionType from '@linc-technologies/linced-common/enums/medical-condition-type';

// Proto: enrolments.MedicalCondition.
export default class MedicalCondition extends DynamicFieldsFragment {
  declare [Type]: 'enrolments/medical-condition';

  @attr('number', { defaultValue: 0 })
  declare type: EnumValue<typeof MedicalConditionType> | 0;

  @attr('number', { defaultValue: 0 })
  declare priority: number;

  @attr('string', { defaultValue: '' })
  declare description: string;

  @attr('string')
  declare startDate: string | undefined;

  @attr('string')
  declare reviewDate: string | undefined;

  @attr('string')
  declare endDate: string | undefined;

  @attr('boolean', { defaultValue: false })
  declare prescribedMedicationHeld: boolean;

  @attr('boolean', { defaultValue: false })
  declare anaphylaxis: boolean;

  @attr('boolean', { defaultValue: false })
  declare highRisk: boolean;
}
